import React from 'react'
import CookieConsent from 'react-cookie-consent'

const CookieBanner = () => (
  <CookieConsent
    location="bottom"
    buttonText="Принять"
    cookieName="uvas-cookie-consent"
    style={{
      background: '#CAF2F3',
      color: 'black',
      fontSize: '16px',
      padding: '20px',
      alignItems: 'center',
      justifyContent: 'space-between',
      flexWrap: 'wrap',
      zIndex: 99999,
    }}
    buttonStyle={{
      background: '#00CAF4',
      color: 'white',
      fontSize: '14px',
      padding: '10px 20px',
      borderRadius: '4px',
      border: 'none',
      cursor: 'pointer',
      marginLeft: '20px',
    }}
    expires={150}
  >
    <span style={{ marginRight: '20px' }}>
      Мы используем файлы cookie для улучшения вашего опыта на нашем сайте.
      Продолжая использовать сайт, вы соглашаетесь с нашей{' '}
      <a href="/cookie-policy" target="_blank">
        политикой использования файлов cookie.
      </a>
    </span>
  </CookieConsent>
)

export default CookieBanner
